import React, { FC, memo } from 'react';
import classNames from 'classnames';
import ArrowUpwardRoundedIcon from '@material-ui/icons/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@material-ui/icons/ArrowDownwardRounded';

import { DataTableColumn, SortAction, SortParam, SortDirections } from './types';
import useStyles from './styles';

interface Props {
  column: DataTableColumn<any>;
  sortBy?: SortParam;
  onSort?: SortAction;
}

const HeaderCellMemoized: FC<Props> = memo(function HeaderCell({ column, onSort, sortBy }) {
  const classes = useStyles();

  const { width, headerCell } = column;
  const { sort, render, padding } = headerCell;
  const { direction } = sortBy;

  const isAscending = direction === SortDirections.Asc;

  const Icon = isAscending ? ArrowUpwardRoundedIcon : ArrowDownwardRoundedIcon;
  const cellClasses = classNames({
    [classes.sortableCell]: sort?.field,
    [classes.paddingNone]: padding === 'none',
    [classes.paddingCheckbox]: padding === 'checkbox',
    [classes.paddingNormal]: padding === 'normal' || !padding,
  });

  function onClickCellSort() {
    const nextDirection = isAscending ? SortDirections.Desc : SortDirections.Asc;
    onSort([{ direction: nextDirection, field: sort.field }]);
  }

  return (
    <div style={{ width }} onClick={!sort ? null : onClickCellSort} className={cellClasses}>
      {render}
      {!!sort && <Icon fontSize="small" color="primary" />}
    </div>
  );
});

export default HeaderCellMemoized;
